/* eslint-disable */
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './redux/store';
import './index.css';
import Loader from './components/Loader';


if (typeof window !== 'undefined') {
  const ResizeObserver =
    window.ResizeObserver;

  window.ResizeObserver = class extends ResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          callback(entries, observer);
        });
      });
    }
  };
}

const LazyApp = React.lazy(() => import('./App'));

ReactDOM.render(
  <Provider store={store}>
    <React.Suspense fallback={<Loader />}>
      <React.StrictMode>
        <LazyApp />
      </React.StrictMode>
    </React.Suspense>
  </Provider>,
  document.getElementById('root'),
);
